<div class="list_item">
  <h3>{{user.Name}}</h3>
  <p style="margin-top: 0.2em;">{{user.Username | deviationTypeName}}
    <span style="float: right" *ngIf="user.Type !== null">{{user.Type | userTypeName}}</span>
  </p>
</div>
